import { serializeObject } from "../common/helper";
import { Request } from "./HttpService";

export const InterviewRequestService = {
  GetAll(pageSize, pageNumber, searchObject) {
    var serializeSearcObjectObject = serializeObject(searchObject);

    return Request(
      `vitae/InterviewRequest/${pageSize}/${pageNumber}?${serializeSearcObjectObject}`
    );
  },
  reject(interviewRequestReject) {
    return Request(`vitae/interviewRequest`, "POST", interviewRequestReject);
  },
  cloneLastInterview(interviewId, interviewRequestId) {
    return Request(
      `vitae/interviewrequest/${interviewId}/${interviewRequestId}`,
      "POST"
    );
  }
};
